import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { loginAccess } from "@api/authenticationApi";
import { useLoginHandler } from "@utils/auth";

const AfterSamsungAccountLogin = () => {
  const navigate = useNavigate();
  const loginHandler = useLoginHandler();
  const [searchParams] = useSearchParams();
  const access_token = searchParams.get("access_token");
  const sign = searchParams.get("sign");
  const after_redirect_url = localStorage.getItem("redirect_url");
  
  useEffect(() => {
    const SamsungAccountLoginClubs = async () => {
      try {
        const res = await loginAccess({
          access_token_sa: access_token,
          sign_sa: sign,
          email: "",
          password: "",
        });
        const data = res.data.Data;
        if (data) {
          loginHandler(data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        navigate(after_redirect_url || "/");
      }
    };

    SamsungAccountLoginClubs();
  }, []);

  return <Box minHeight="50vh"></Box>;
};

export default AfterSamsungAccountLogin;
